import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'includes',
  standalone: true,
})
export class IncludesPipe implements PipeTransform {
  /**
   * @description Returns a boolean based on if the given array has a given value.
   **/
  transform<T>(arr: T[], value: T): boolean {
    return arr.includes(value);
  }
}
